import React from 'react';

class BorderHeader extends React.Component {
	getNum(numStr) {
		var num = '';
		for(var w = 0; w !== numStr.length; w++) {
			if(!isNaN(parseInt(numStr[w]))) {
				num += numStr[w];
			}
			else {
				break;
			}
		}

		return parseInt(num);
	}

	render() {
		const color = this.props.borderColor;
		var size = this.props.size;

		if(!size) {
			size = {width: '100%', height: '4vmin'};
		}

		var fontSize = (this.getNum(size.height) * 0.6) + "vmin"

		return (

			<div className={'BorderHeader'} style={{width: size.width, height: size.height, borderColor: color, fontSize: fontSize}}>
				{this.props.label}
			</div>
		);
	}

}

class BorderHeaderBox extends React.Component {


	render() {
		const color = this.props.borderColor;
		const size = this.props.size || {width: '100%', height: 'auto'};

		return (
			<div className={'BorderHeaderBox'} style={{width: size.width, height: size.height}} >
				<BorderHeader borderColor={color} size={{width: size.width, height: '3vmin'}} label={this.props.label} />
				<div className={'BorderHeaderBox-Content'}>
					{this.props.content}
				</div>
			</div>

		);

	}


}

export {BorderHeader, BorderHeaderBox};